<template>
  <div>
    <div class="subtitle1 mb-3">
      {{ $t("modals.exportUsersAndDevicesTrend.subtitle") }}
    </div>
    <v-radio-group v-model="localValue.type" hide-details>
      <v-radio
        v-for="choice in choices"
        :key="choice"
        class="mb-3"
        :value="choice"
        :ripple="false"
        :label="$t(`modals.exportUsersAndDevicesTrend.choices.${choice}`)"
      ></v-radio>
    </v-radio-group>
    <v-select
      v-model="localValue.date"
      :items="presets"
      density="compact"
      variant="outlined"
      hide-details
      rounded
      class="rounded-lg w-30 mt-2"
      item-title="label"
      item-value="value"
      return-object
      data-testid="top-delta-widget-range-select"
    ></v-select>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from "vue";
import type { DialogDataConfig } from "@/_store/dialogs.module";
import { camelCase } from "lodash";
import { useI18n } from "vue-i18n";
import { getNDaysAgo, type PresetDate } from "@/constants/date-range-picker.ts";
import { MspUsersAndDevicesTrendExportOption } from "@/constants/msp.ts";

export default defineComponent({
  props: {
    config: {
      type: Object as PropType<DialogDataConfig>,
      required: true,
    },
  },
  setup(_, { emit }) {
    const i18n = useI18n();

    const presets = computed<PresetDate[]>(() => {
      return [
        {
          label: i18n.t("dateRangePicker.lastSevenDays"),
          value: getNDaysAgo(7),
        },
        {
          label: i18n.t("dateRangePicker.lastThirtyDays"),
          value: getNDaysAgo(30),
        },
        {
          label: i18n.t("dateRangePicker.lastNinetyDays"),
          value: getNDaysAgo(90),
        },
      ];
    });

    const localValue = ref({
      type: MspUsersAndDevicesTrendExportOption.BOTH,
      date: presets.value[0],
    });

    watch(
      localValue,
      (newVal) => {
        emit("update:localValue", newVal);
      },
      { deep: true, immediate: true }
    );

    return {
      choices: Object.values(MspUsersAndDevicesTrendExportOption),
      localValue,
      MspUsersAndDevicesTrendExportOption,
      camelCase,
      presets,
    };
  },
});
</script>

<style lang="scss" scoped></style>
